import { DBDef_OrderGroup } from '@app/pathway-shared';
import { createSearchIntegration } from '@app/styles';
import { resolveEntity } from '@nu-art/thunderstorm-frontend';
import { ModuleFE_Action, ModuleFE_OrderGroup } from '../../_entity.js';
import { Manager_OrderGroup } from '../../ui/_managers/Manager_OrderGroup/Manager_OrderGroup.js';
import { SearchAddOn_ByTag } from '@app/hcs-frontend/search/index';
import { ModuleFE_Tag } from '@app/hcs-frontend';
const resolveOrderGroup = resolveEntity(ModuleFE_OrderGroup);
const { WorkHubItem, UtilObject, SearchItem } = createSearchIntegration({
    module: ModuleFE_OrderGroup,
    dbDef: DBDef_OrderGroup,
    tag: ['OG', 'Order Group'],
    labelField: 'name',
    modulesToAwait: [ModuleFE_OrderGroup, ModuleFE_Action, ModuleFE_Tag],
    ManagerComponent: Manager_OrderGroup,
    extraAddOnKeys: [SearchAddOn_ByTag.key],
    extraSearchAddOns: {
        [SearchAddOn_ByTag.methodName]: (result) => {
            const item = resolveOrderGroup(result.id);
            return item?.tagGroups;
        },
    },
});
export const WorkHubItem_OrderGroup = WorkHubItem;
export const UtilObject_OrderGroup = UtilObject;
export const SearchItem_OrderGroup = SearchItem;
//# sourceMappingURL=order-group.js.map